import React, { useState } from "react";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";
import { Alert, Button, Card, CardBody, CardHeader, Form, FormGroup, FormText, Input, Label } from "reactstrap";
import Loading from "../components/Loading";
import { checkWebsite, createStore } from "../utils/stores";

export const AddStoreComponent = () => {
  const history = useHistory();
  const { getAccessTokenSilently } = useAuth0();
  const [form, setForm] = useState({ name: "", website: "" });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onChange = (e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const token = await getAccessTokenSilently();
      const { domain, taken } = await checkWebsite(form.website, token);
      if (taken) throw new Error(`${domain} is already a KuzFit store`);
      const id = await createStore({ name: form.name.trim(), domain }, token);
      history.push(`/stores/${id}`);
    } catch (err) {
      setError(err.message || "Could not add the store");
      setSubmitting(false);
    }
  };

  return (
    <Card>
      <CardHeader><h1 className="mb-0">Add a store</h1></CardHeader>
      <CardBody>
        {error && <Alert color="danger">{error}</Alert>}
        <Form onSubmit={onSubmit}>
          <FormGroup>
            <Label for="name">Store name</Label>
            <Input id="name" name="name" value={form.name} onChange={onChange} required />
          </FormGroup>
          <FormGroup>
            <Label for="website">Website</Label>
            <Input id="website" name="website" value={form.website} onChange={onChange} placeholder="shop.example.com" required />
            <FormText>Where your product images are. KuzFit only fetches images from this website.</FormText>
          </FormGroup>
          <div className="d-flex">
            <Button color="secondary" className="me-2" type="button" onClick={() => history.push("/stores")} disabled={submitting}>
              Cancel
            </Button>
            <Button color="primary" type="submit" disabled={submitting}>
              {submitting ? "Adding..." : "Add store"}
            </Button>
          </div>
        </Form>
      </CardBody>
    </Card>
  );
};

export default withAuthenticationRequired(AddStoreComponent, { onRedirecting: () => <Loading /> });
